/* eslint-disable @typescript-eslint/camelcase */

import * as Rox from "rox-browser";
import { BcsFlag, FcsFlag } from "../unleash";

const RoxPermissionBulkUpload = {
  permission_bulk_upload_enable: new Rox.Flag(false),
  permission_bulk_upload_add_promo_discount: new Rox.Flag(false),
  permission_bulk_upload_update_promo_discount: new Rox.Flag(false),
  permission_bulk_upload_update_custom_status: new Rox.Flag(false),
  permission_bulk_upload_district_vendor: new Rox.Flag(false),
  permission_bulk_upload_international_document: new Rox.Flag(false),
  config_max_file_district: new Rox.RoxNumber(25000),
  config_max_file_base_rate: new Rox.RoxNumber(2000000),
  permission_bulk_upload_type_update_retail_base_rate: new Rox.Flag(false),
  permission_bulk_upload_type_service_delay: new Rox.Flag(false),
  permission_bulk_upload_type_category_commodity: new Rox.Flag(false)
};

const BcsPermissionBulkUpload = {
  config_max_row_file_config_cargo: new BcsFlag.NumberFlag(502),
}

const FcsPermissionBulkUpload = {
  permission_bulk_upload_type_config_cargo_v2: new FcsFlag.Flag(false),
  permission_bulk_upload_type_duty_tax_configuration: new FcsFlag.Flag(false)
};

export const FlagsPermissionBulkUpload = {
  ...FcsPermissionBulkUpload,
  ...RoxPermissionBulkUpload,
  ...BcsPermissionBulkUpload
}

export function initFlagsPermissionBulkUpload() {
  // register flags with namespaces for better grouping
  Rox.register("featureBulkUpload", RoxPermissionBulkUpload);
  BcsFlag.register("featureBulkUpload", BcsPermissionBulkUpload);
  FcsFlag.register("featureBulkUpload", FcsPermissionBulkUpload);
}
